var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTymeplusPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13213_34504)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 62,
    height: 62,
    rx: 31,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4393 27.9493C53.2902 24.3583 52.8094 22.1565 51.2593 20.6064C49.0124 18.3594 45.3956 18.3594 38.1626 18.3594H32.4086C25.1753 18.3594 21.5587 18.3594 19.3116 20.6064C17.0646 22.8535 17.0646 26.4701 17.0646 33.7034C17.0646 40.9364 17.0646 44.5532 19.3116 46.8001C21.5587 49.0472 25.1753 49.0472 32.4086 49.0472H38.1626C45.3956 49.0472 49.0124 49.0472 51.2593 46.8001C52.8094 45.2503 53.2902 43.0483 53.4393 39.4573",
    stroke: "#2D53DA",
    strokeWidth: 1.11818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1877 27.9492H48.196C44.7738 27.9492 41.9995 30.5252 41.9995 33.7032C41.9995 36.8812 44.7738 39.4572 48.196 39.4572H53.1877C53.3477 39.4572 53.4274 39.4572 53.495 39.4531C54.5293 39.3901 55.3531 38.6252 55.4209 37.6646C55.4253 37.6019 55.4253 37.5277 55.4253 37.3794V30.027C55.4253 29.8787 55.4253 29.8045 55.4209 29.7418C55.3531 28.7813 54.5293 28.0163 53.495 27.9533C53.4274 27.9492 53.3477 27.9492 53.1877 27.9492Z",
    fill: "#ED3241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7375 26.0332H32.4094",
    stroke: "#2D53DA",
    strokeWidth: 1.11818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.736 33.7031H47.7523",
    stroke: "white",
    strokeWidth: 2.34818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13213_34504",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13213_34504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13213_34504",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTymeplusPay);
export default __webpack_public_path__ + "static/media/TymeplusPay.7a3b295ff9c1c1f3ed48c18bbe44a9b3.svg";
export { ForwardRef as ReactComponent };